import { OurStory } from "@/components/OurStory";

export default function About() {
  return (
    <div className="pt-20 lg:pt-24" data-testid="about-page">
      <OurStory />
    </div>
  );
}
